import { atom } from "recoil";

export const isCreateWorkSpecificationDialogOpen = atom<boolean>({
    key: "isCreateWorkSpecificationDialogOpen",
    default: false
});
